/* eslint-disable react/jsx-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
// components
import { Grid, Radio, Message } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';

// styles
import { WrapperRadio } from '../../../assets/styles/styles';

const CardDeclarationsData = (props) => {
  /* istanbul ignore next */
  const { taxDeclaration, disabled, onChange } = props;
  /* istanbul ignore next */
  return (
    <SimpleCard
      contentHeader={
        <article className="d-flex flex-column">
          <p className="simplecard__title">Declaraciones</p>
        </article>
      }
      disabled={disabled}
    >
      <Grid className="m-0 padding-16 p-md-6">
        <Grid className="p-0">
          <h5 className="line-height-20 line-height-md-24">Selecciona la opción que te identifique</h5>
        </Grid>
        <Grid className="p-0 mt-2 align-items-sm-start align-items-md-center">
          <>
            <WrapperRadio>
              <Radio
                id="1112"
                name="chile"
                label="No soy Estadounidense ni pago impuestos en un país distinto de Chile"
                checked={taxDeclaration.value.chile}
                onChange={() =>
                  onChange({
                    field: 'taxDeclaration',
                    property: 'value',
                    value: { ...taxDeclaration.value, chile: true, usa: false },
                  })
                }
              />
            </WrapperRadio>
            <WrapperRadio>
              <Radio
                id="1113"
                name="usa"
                label="Soy Estadounidense y/o pago impuestos en un país distinto de Chile"
                checked={taxDeclaration.value.usa}
                onChange={() =>
                  onChange({
                    field: 'taxDeclaration',
                    property: 'value',
                    value: { ...taxDeclaration.value, usa: true, chile: false },
                  })
                }
              />
            </WrapperRadio>
          </>
        </Grid>
        {taxDeclaration.value.usa && (
          <Message
            className="mt-2"
            description={
              <p style={{color:'#B00009'}}>
                Esta opción te impide continuar tu proceso de ingreso de Socio con Cuenta Vista de
                manera digital.
                <br />
                Puedes continuar con tu ingreso en cualquiera de nuestras sucursales
              </p>
            }
            title=""
            type="error"
            closer={null}
          />
        )}
      </Grid>
    </SimpleCard>
  );
};
/* istanbul ignore next */
CardDeclarationsData.defaultProps = {
  taxDeclaration: { value: { chile: false, world: false, usa: false } },
  disabled: false,
  onChange: () => null,
};

CardDeclarationsData.propTypes = {
  taxDeclaration: PropTypes.shape({
    value: PropTypes.shape({
      chile: PropTypes.bool,
      world: PropTypes.bool,
      usa: PropTypes.bool,
    }),
  }),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CardDeclarationsData;
